import { Stack, Typography } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { FormTextInput } from 'src/components/FormPart/FormTextInput';
import { FormComponentProps } from 'src/components/FormPart/types';
import { KeywordFormData } from '../../types';

type CreateKeywordFormProps = {
  onNameChange: (name: string) => void;
};

export const CreateKeywordForm: FC<FormComponentProps<KeywordFormData, CreateKeywordFormProps>> = (props) => {
  const { form, onNameChange } = props;

  const id = form.watch('id');
  const name = form.watch('name');

  useEffect(() => {
    onNameChange(name ?? '');
  }, [name, onNameChange]);

  return (
    <Stack>
      <FormTextInput
        form={form}
        fieldName="name"
        label="Keyword"
        placeholder="Enter Keyword Name"
        validation={{
          required: 'Keyword name is required',
        }}
        helperText=" "
        margin="none"
        size="small"
      />
      {id && (
        <Typography variant="caption" fontStyle="italic">
          NOTE: All campaigns associated with this keyword will be updated to use the newly specified keyword.
        </Typography>
      )}
    </Stack>
  );
};
